import React from 'react';
import './About.css';
import { FaCheckCircle, FaAward, FaUserMd, FaGlobe } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title" style={{ textAlign: 'left' }}>
              About <span className="gradient-text">Grandis Business Solutions</span>
            </h2>
            <p className="about-description">
              Grandis Business Solutions, founded in December 2020 by Vinod Sivakumar and Haseeb Ahsan, 
              aims to revolutionize healthcare IT by offering digital hospital management solutions that 
              enhance care delivery and operational efficiency.
            </p>
            <p className="about-description">
              With great excellence in healthcare technology, Grandis Business Solutions 
              Pvt Ltd has been at the forefront of digital transformation in the healthcare sector.
            </p>
            <p className="about-description">
              With a robust suite of customizable software solutions and a client-centric approach, 
              Grandis is poised to inspire healthier communities and elevate healthcare services globally. 
              We specialize in delivering comprehensive, end-to-end healthcare management solutions 
              that streamline operations, enhance patient care, and ensure compliance with international 
              standards including NABH and JCI accreditations.
            </p>
            
            <div className="about-features">
              <div className="about-feature">
                <FaCheckCircle className="feature-icon" />
                <div>
                  <h4>Proven Track Record</h4>
                  <p>70+ successful implementations across healthcare facilities</p>
                </div>
              </div>
              <div className="about-feature">
                <FaCheckCircle className="feature-icon" />
                <div>
                  <h4>Innovation Driven</h4>
                  <p>Cutting-edge technology with continuous product evolution</p>
                </div>
              </div>
              <div className="about-feature">
                <FaCheckCircle className="feature-icon" />
                <div>
                  <h4>Customer-Centric</h4>
                  <p>24/7 dedicated support and customized solutions</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-cards">
            <div className="about-card">
              <div className="card-icon-wrapper">
                <FaAward className="card-icon" />
              </div>
              <h3>Guaranteed service</h3>
              <p>Committed to Your Success</p>
            </div>
            <div className="about-card">
              <div className="card-icon-wrapper">
                <FaUserMd className="card-icon" />
              </div>
              <h3>Expert Team</h3>
              <p>Healthcare IT Specialists</p>
            </div>
            <div className="about-card">
              <div className="card-icon-wrapper">
                <FaGlobe className="card-icon" />
              </div>
              <h3>Quality Delivery</h3>
              <p>Excellence in Every Implementation</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
